import React, { useEffect } from "react";
import Shop from "../components/Shop/shop";
import Navbar from "../components/Navbar/navbar";
import Footer from "../components/Footer/footer";

const ShopPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <Shop />
      <Footer />
    </div>
  );
};

export default ShopPage;
